import { Style } from '@wix/thunderbolt-becky-types'
import { StylableDriver, StylableEditor, StylesheetDriver } from '@wixc3/stylable-panel-drivers'
import * as stylableSantaFlatten from '@wix/stylable-santa-flatten/cjs'
import _ from 'lodash'

const getStylableCompFonts = (styleItem: Style) => {
	const stcss = getSTCSS(styleItem)
	return stylableSantaFlatten.fontStylable.findFontsInCss(stcss, () => true, true)
}

const getSTCSS = (styleItem: Style): string =>
	_.get(styleItem, ['style', 'properties', '$st-css'], _.get(styleItem, ['style', 'properties', 'st-css'], ''))

const getStylableCompCss = (
	stylableEditorInstance: StylableEditor,
	namespace: string,
	styleItem: Style,
	isMobileView: boolean
	/* themeCounter: number*/
) => {
	const componentStyle = getSTCSS(styleItem)

	const styleWithDirectives = getStyleWithDirectives(componentStyle, isMobileView)
	const meta = getTransformedMeta(stylableEditorInstance.stylableDriver, namespace, styleWithDirectives)
	return meta.outputAst!.toString()
}

const getStyleWithDirectives = (componentStyle: string, isMobileView: boolean): string => {
	return stylableSantaFlatten.addStylableDirectiveRules(componentStyle, isMobileView, {
		breakpoints: true,
		siteColors: true,
		fontClasses: true,
		additionalJsModules: true,
	})
}

const getTransformedMeta = (
	stylableDriver: StylableDriver,
	namespace: string,
	componentStyle: string
): ReturnType<StylesheetDriver['getMeta']> => {
	stylableDriver.writeFile('/currently-transpiling.st.css', '') // TODO we can refactor this to not use writeFile

	const metaBefore = stylableDriver.stylable.fileProcessor.processContent(
		componentStyle,
		'/currently-transpiling.st.css'
	)
	metaBefore.namespace = namespace
	const { meta } = stylableDriver.stylable.transform(metaBefore)
	return meta
}

export { getStylableCompCss, getTransformedMeta, getStylableCompFonts, getSTCSS, getStyleWithDirectives }
